import React from 'react';

// BL-177 Step 2p-D2: shared navy/turquoise 32px face; coarse pointers retain a 44px hit area.
// Pressed = a 1px movement with the same face shadow; disabled = flat at 45%.
// Variants: primary (navy), go (turquoise), light (navy), pill (navy).
// Always a real <button>; pass `type="submit"` explicitly when it submits a form.
const VARIANTS = ['primary', 'go', 'light', 'pill'];

const Button3D = React.forwardRef(function Button3D({ variant = 'primary', type = 'button', className = '', children, ...rest }, ref) {
    const kind = VARIANTS.includes(variant) ? variant : 'primary';
    return (
        <button ref={ref} type={type} data-ia-btn3d={kind} className={`ia-btn3d ia-btn3d--${kind} ${className}`} {...rest}>
            {children}
        </button>
    );
});

export default Button3D;
